import { tagAttributeList } from './request';
export default {
  data() {
    return {
      propertyColumns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '属性名称'
        },
        dataIndex: 'label',
        key: 'label',
        align: 'center'
      }
      // {
      //   title: '创建类型',
      //   dataIndex: 'type',
      //   key: 'type',
      //   align: 'center'
      // },
      // {
      //   title: '创建人',
      //   dataIndex: 'userName',
      //   key: 'userName',
      //   align: 'center',
      //   ellipsis: true,
      //   customRender: (text, record) => (
      //     <a-tooltip placement="topLeft" title={record.userName}>
      //       {record.userName}
      //     </a-tooltip>
      //   )
      // },
      // {
      //   title: '更新时间',
      //   dataIndex: 'updateAt',
      //   key: 'updateAt',
      //   align: 'center'
      // }
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   key: 'operation',
      //   align: 'center',
      //   width: 180,
      //   scopedSlots: {customRender: 'operation'}
      // }
      ],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      propertyTableData: [],
      form: {
        tagsName: '',
        attributeName: ''
      }
    };
  },
  created() {
    Object.assign(this.form, this.$route.params);
    this.onSearch();
  },
  mounted() {},
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await tagAttributeList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.propertyTableData = items;
      this.pagination.total = totalNum;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    }
  }
};